import "./src/styles/global.css";
import React from "react"
import { ConsentProvider } from "./src/components/consent/ConsentContext"
import { trackPageView } from "./src/components/consent/loadTrackers"

export const wrapRootElement = ({ element }) => (
  <ConsentProvider>{element}</ConsentProvider>
)

// The initial page view is sent when consent is applied.
export const onRouteUpdate = ({ prevLocation }) => {
  if (prevLocation) trackPageView()
}
